import { PageLayout } from "@/components/PageLayout";

interface BaseFormLayoutProps {
  title?: React.ReactNode;
  rightContent?: React.ReactNode;
}

export const BaseFormLayout: React.FC<React.PropsWithChildren & BaseFormLayoutProps> = ({
  children,
  title,
  rightContent,
}) => {
  return (
    <PageLayout title={title} extraRight={rightContent}>
      {children}
    </PageLayout>
  );
};
